import logo from '../assets/images/logo.png';

const phone: string = '+52 (624) 155-1025';
const email: string = 'rolandovc963@gmail.com';

const appBarMock = {
    logo,
    name: 'ROLANDO VC',
    menu: [
        { path: '/tours', description: 'TOURS & SERVICES'},
        { path: '/contact', description: 'CONTACT ME'}
    ],
    phone,
    email,
    url: 'https://rolandovc.com/',
    urlText: `Rolando VC - Los Cabos`,
    footer: {
        phone,
        email,
        relatedPages: [
            { url: 'https://nobaddaystransport.com/', urlText: `No Bad Days Transp - Los Cabos`},
        ]
    }

};

export default appBarMock;